module.exports = __webpack_public_path__ + "media/images/icons/pinterest_black-3418f4bfbbaf913ab46fd35d5ec7691d.svg";